import React from 'react';
import { Outlet } from 'react-router-dom';
import TopBar from './topBar';
import Aside from './aside';

const MainLayout = () => {
    return (

        <div className='main-wrapper'>
            <Aside />
            <div className='content-wrapper'>
                <TopBar />

                <div>
                    <Outlet />  {/* This renders the matched child route */}
                </div>
            </div>

        </div>
    );
};
export default MainLayout;